import {
  SET_CURRENT_USER,
  NOT_ENTER_USER,
  SET_USER_LOGOUT,
  SET_LANGUAGE,
  SET_ID_ALERT
} from './actionTypes';
import { getApiInstance, initAuthorized, apiInit } from 'utils/apiClient';

export const login = userData => async dispatch => {
  const api = getApiInstance();

  await api
    .post('/auth-token/', userData)
    .then(res => {
      const { token } = res.data;
      localStorage.setItem('access_token', token);
      initAuthorized(token);
      const decoded = token;
      dispatch(setCurrentUser(decoded));
      window.location.href = '/';
    })
    .catch(e => {
      const err =
        e.response.status === 403
          ? '403'
          : e.response.data.non_field_errors
          ? e.response.data.non_field_errors[0]
          : '1000';

      dispatch(setNotEnterUser(err));
    });
};

export const logout = () => async dispatch => {
  const api = getApiInstance();
  await api
    .get('/logout')
    .then(() => {
      dispatch(setUserLogout());
    })
    .catch(err => {
      console.log(err.response);
    });
  localStorage.removeItem('access_token');
  apiInit(false);
  dispatch(setCurrentUser({}));
  window.location.href = '/';
};

export const userState = userInfo => dispatch => {
  dispatch({ type: SET_LANGUAGE, payload: userInfo });
};

export const setIdAlert = alertInfo => dispatch => {
  dispatch({ type: SET_ID_ALERT, payload: alertInfo });
};

export const setCurrentUser = user => ({
  type: SET_CURRENT_USER,
  payload: user
});

export const setNotEnterUser = err => ({
  type: NOT_ENTER_USER,
  payload: err
});

export const setUserLogout = () => ({
  type: SET_USER_LOGOUT
});
